import { cn } from "@/lib/chillnn/cn";

import type { OverSiteControllerPeopleNumType } from "../_hooks/use-over-site-controller-people-num-type";

type Props = {
	overSiteControllerPeopleNumType: OverSiteControllerPeopleNumType;
};

export const QuestionRoomDynamicPriceSettings = ({ overSiteControllerPeopleNumType }: Props) => {
	return (
		<>
			{overSiteControllerPeopleNumType === "DynamicPrice" && (
				<div className={cn("my-8 rounded bg-zinc-100 p-4 text-sm leading-6")}>
					<p>
						※人数超過時、サイトコントローラーで設定できる最大人数の1人当たりの金額を宿泊者人数分で掛け合わせた料金算出をし、ダイナミックプライシングを実現します。
					</p>
					<div className="mt-4">
						<p>(料金算出例)</p>
						<div className="space-y-2">
							<div>
								<p className="font-semibold">[設定:サイトコントローラの設定可能最大人数6人]</p>
								<p className="ml-2">サイトコントローラ上で6人宿泊時、1人当たり5,000円の設定</p>
							</div>
							<div>
								<p className="font-semibold">
									[部屋:部屋上限人数8人] 8人で予約した場合、この際の宿泊料金は
								</p>
								<p className="ml-2">宿泊料金 = 5,000円 × 8人</p>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

QuestionRoomDynamicPriceSettings.displayName = "QuestionRoomDynamicPriceSettings";
